/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaProductpdfSpecificationViewProps } from './citta-productpdf-specification';

export default (props: ICittaProductpdfSpecificationViewProps) => {
    const {PdfSpecificationContainer, PdfSpecificationContentContainer, PdfSpecificationContentShow, PdfSpecificationContent} = props;
    const {pdfSpecificationTitle} = props.config;

    if (PdfSpecificationContentShow) {
        return (
            <Module {...PdfSpecificationContainer}>
                <Node {...PdfSpecificationContentContainer}>
                    <Node {...PdfSpecificationContent}>{pdfSpecificationTitle?.endsWith(' AU') ? pdfSpecificationTitle.slice(0, -3) : pdfSpecificationTitle}</Node>
                </Node>
            </Module>
        );
    } else {
        return null;
    }
};
